import cart from '../helpers/cart-helper'
import refs from '../helpers/refs'
import TabTrap from '../helpers/tab-trap'
import priceHelper from '../helpers/price'
import ButtonHelper from '../helpers/button-helper'
import datalayer from '../helpers/datalayer'

class MSlideOutCart {
  constructor (slideOutCart) {
    this.slideOutCart = slideOutCart
    this.$refs = refs(this.slideOutCart)
    this.showing = false

    this.tabTrap = new TabTrap(this.slideOutCart)

    this.init()
  }

  init () {
    // Close button
    this.$refs.closeSlideOutCart.addEventListener(
      'click',
      this.hide.bind(this)
    )

    // the free shipping motivator is only on the motivator progress bar
    this.freeShippingMinimum = this.$refs.freeShippingMotivator.dataset.freeShippingMinimum ? this.$refs.freeShippingMotivator.dataset.freeShippingMinimum : 0

    this.initCartItemEventHandlers()

    // Event handlers
    document.addEventListener('cart:show', this.show.bind(this))
    document.addEventListener('cart:hide', this.hide.bind(this))
    document.addEventListener('cart:toggle', this.toggle.bind(this))
    document.addEventListener('cart:updated', this.renderCart.bind(this))
  }

  show () {
    this.showing = true
    this.slideOutCart.classList.remove('hidden')
    this.tabTrap.initEvents()
  }

  hide () {
    this.showing = false
    this.slideOutCart.classList.add('hidden')
    this.tabTrap.destroyEvents()
  }

  toggle () {
    if (this.showing) {
      this.hide()
    } else {
      // need to pass current cart for upsells

      cart.getCart().then(thisCart => this.updateUpsells(thisCart))
      this.show()
    }
  }

  renderCart () {
    cart.getCart().then((thisCart) => {
      // Update heading depending on if cart is empty or not
      const cartHeader = window.cartStrings.itemsInCart.replace('[numitems]', thisCart.item_count)
      this.$refs.slideOutCartHeading.innerText =
      thisCart.item_count > 0 ? cartHeader : 'Your cart is empty.'

      // Clear container
      const container = document.querySelector('[data-m-cart-list-container]')

      // Render new HTML for each line item
      const newHTML = thisCart.items
        .map((item, index) =>
          this.productHTML(
            item.title,
            item.id,
            item.url,
            item.image,
            item.price,
            item.quantity,
            index,
            item.key,
            item.sku,
            item.handle
          )
        )
        .join('')
      // On item remove the HTML is updated
      // So, we don't always have to replace the HTML
      // By not replacing the HTML we can avoid flickering
      if (container.innerHTML !== newHTML) {
        container.innerHTML = newHTML
      }

      this.updateUpsells(thisCart)

      // Re-init slideOut cart item event handlers
      this.initCartItemEventHandlers()
      document.dispatchEvent(
        new CustomEvent('cartItems:updated', { detail: cart })
      )

      // update shipping info - OLD STYLE
      // Looks like this only exists on CG, c-cart-summary around line 20
      if (this.$refs.freeshipping) {
        const freeshipping = thisCart.items_subtotal_price > this.$refs.freeshipping.dataset.minimum
        if (this.$refs.freeshipping && this.$refs.freeshipping.children) {
          this.$refs.freeshipping.children[0].classList.toggle('hidden', !freeshipping)
          this.$refs.freeshipping.children[1].classList.toggle('hidden', freeshipping)
        }
      }

      // update totals, shipping info, motivator bar - NEW STYLE
      if (this.freeShippingMinimum > 0) {
        let shippingCost = 0
        let cartShippingText = 'FREE'
        let subtotal = 0
        let allGiftCards = true

        thisCart.items.forEach((item) => {
          if (!item.gift_card) {
            allGiftCards = false
            subtotal = subtotal + item.price
          }
        })

        // If the only items in the cart are gift cards, there is no shipping regardless of cost
        if (!allGiftCards) {
          if (window.localeInformation.market === 'canada') {
            if (subtotal > 0 && subtotal < 15000) {
              shippingCost = 1999
            } else if (subtotal < this.freeShippingMinimum) {
              shippingCost = 3499
            }
          } else if (subtotal > 0 && subtotal < this.freeShippingMinimum) {
            // US as default
            shippingCost = 1499
          }

          // For 2024 slide-out-cart changes, now need to change entire HTML snippet of the shipping motivator to be sure of proper styling
          const remainder = this.freeShippingMinimum - subtotal
          const remainderText = priceHelper.formatPrice(remainder, false)
          if (subtotal <= 0) {
            this.$refs.freeShippingMotivator.innerHTML = ''
          } else if (subtotal < (this.freeShippingMinimum / 2)) {
            const shippingMotivatorText1 = window.cartStrings.shippingMotivator1
            this.$refs.freeShippingMotivator.innerHTML = `<p class="text-brand free-shipping-not-halfway">${shippingMotivatorText1.replace('0', remainderText)}</p>`
          } else if (subtotal < this.freeShippingMinimum) {
            const shippingMotivatorText2 = window.cartStrings.shippingMotivator2
            this.$refs.freeShippingMotivator.innerHTML = `<p class="font-bold text-brand free-shipping-halfway">${shippingMotivatorText2.replace('0', remainderText)}</p>`
          } else {
            this.$refs.freeShippingMotivator.innerHTML = `<p class="font-bold free-shipping">${window.cartStrings.freeShippingAtCheckout}</p>`
          }
        }

        if (subtotal > 0) {
          // console.log(' subtotal > 0')
          this.updateShippingProgressBar(subtotal)
          if (allGiftCards) {
            // console.log('all gifts')
            this.$refs.shippingProgressBarWrapper.classList.add('hidden')
            this.$refs.freeShippingMotivator.classList.add('hidden')
          } else {
            // console.log('not all gifts')
            this.$refs.shippingProgressBarWrapper.classList.remove('hidden')
            this.$refs.freeShippingMotivator.classList.remove('hidden')
          }
          this.$refs.checkoutButton.classList.remove('hidden')
          this.$refs.shopButton.classList.add('hidden')
        } else {
          this.$refs.shippingProgressBarWrapper.classList.add('hidden')
          this.$refs.freeShippingMotivator.classList.add('hidden')
          this.$refs.checkoutButton.classList.add('hidden')
          this.$refs.shopButton.classList.remove('hidden')
        }

        // Update the number of items in cart on subtotal line
        let subtotalItems = window.cartStrings.cartItems.replace('[count]', 0)
        if (thisCart.item_count === 1) {
          subtotalItems = window.cartStrings.cartItem.replace('[count]', 1)
        } else if (thisCart.item_count > 1) {
          subtotalItems = window.cartStrings.cartItems.replace('[count]', thisCart.item_count)
        }
        this.$refs.subtotalCount.innerText = subtotalItems

        // Set cart total
        const cartWithShipping = thisCart.items_subtotal_price + shippingCost
        if (shippingCost > 0) {
          cartShippingText = priceHelper.formatPrice(shippingCost, false)
        }
        this.$refs.shippingCost.innerText = cartShippingText
        this.$refs.subtotalPrice.innerText = priceHelper.formatPrice(cartWithShipping, false)
      } else {
        // OLD STYLE update price - set cart total (no motivator, no shipping, USD only)
        this.$refs.subtotalPrice.innerText = `$${(
          thisCart.items_subtotal_price / 100
        ).toFixed(2)}`
      }

      // Set view cart button
      // button removed 9/2024 per Sarah - leaving as conditional in case she changes her mind
      const viewCartBtn = this.$refs.viewCartButton
      if (viewCartBtn) {
        const innerElem = viewCartBtn.children.length > 0 ? viewCartBtn.children[0] : viewCartBtn
        innerElem.innerText = `View Cart (${cart.item_count})`
      }
    })
  }

  productHTML (
    title,
    productID,
    productURL,
    imgURL,
    price,
    quantity,
    line,
    key,
    sku,
    handle
  ) {
    // Copy-pasted from browser HTML
    const intlPrice = priceHelper.formatPrice(price, false)
    const imgUrlSmall = imgURL ? imgURL + '&width=200' : window.imageStrings.cartNoImageUrl
    return `<li class="border-b border-smoke-dark flex items-center py-4 w-full" ref="cartItem" data-item-key="${key}">
        <a class="block flex-shrink-0 mr-4 lg:mr-8 w-18 h-18 lg:w-30 lg:h-30" href="${productURL}">
          <figure class="o-aspect-ratio">
            <img alt="${title}" class="o-aspect-ratio__content object-cover" height="200" loading="lazy" src="${imgUrlSmall}" width="200">
          </figure>
        </a>

        <div class="w-full">
          <div class="flex items-start justify-between mb-4">
            <a class="text-body-3" href="${productURL}">
              ${title}
            </a>

            <p class="ml-4 lg:ml-8 text-number-1 lg:text-number-2">
              <span class="sr-only">Price: </span>${(intlPrice)}
            </p>
          </div>

          <div class="flex items-center">
            <span class="font-bold text-label-1 uppercase">
              Quantity
            </span>

            ${
  /* <select ref="update" class="a-select ml-3" data-product-id="${productID}">
                ${[...Array(Math.max(5, quantity)).keys()].map(index => `<option ${index === (quantity - 1) ? 'selected' : ''} value="${index + 1}" >
                  ${index + 1}
                </option>`)}
            </select> */ ''
            }
            <p class="ml-3 font-bold">
              ${quantity}
            </p>
            <span class="lg:hidden w-full"></span>

            <button ref="remove" class="font-bold ml-8 text-label-1 text-black underline uppercase" data-product-id="${productID}" data-product-handle="${handle}" data-product-sku="${sku}" data-product-qty="${quantity}">
              Remove
            </button>
          </div>
        </div>
      </li>`
  }

  reccosHTML (
    title,
    productID,
    variantID,
    url,
    imgURL,
    price,
    index,
    sku,
    handle
  ) {
    const intlPrice = priceHelper.formatPrice(price, false)
    const imgUrlSmall = imgURL ? imgURL + '&width=80' : window.imageStrings.reccoNoImageUrl
    return `<li class="c-upsell-slider__slide glide__slide w-3/5">
      <div class="flex flex-row gap-4 justify-start cart-upsell-product" data-product-id="${productID}" data-variant-id="${variantID}">
        <div class="cart-upsell-product__link mb-2">
          <a class="block" href="${url}" ref="productLink"
            data-product-handle="${handle}"
            data-product-id="${productID}"
            data-variant-id="${variantID}"
            data-product-position="${index}"
            data-product-list="Slide-out cart reccomendations"
          >
            <img alt="${title}" class="c-upsell-slider__img"
              height="80" width="80"
              loading="lazy"
              src="${imgUrlSmall}">
            </img>
          </a>
        </div>
        <div>
          <a class="block" href="${url}" ref="productLink"
            data-product-handle="${handle}"
            data-product-id="${productID}"
            data-variant-id="${variantID}"
            data-product-position="${index}"
            data-product-list="Slide-out cart reccomendations"
          >
            <h4 class="font-bold text-body-3 text-charcoal mb-2 c-upsell-slider__title">${title}</h4>
          </a>
          <div class="text-number-1 text-charcoal" data-shopify-price="${price}">
            ${intlPrice}
          </div>
        </div>
      </div>
      <button class="a-button group style-stroke border-2 border-grey-700 text-button-1 text-charcoal uppercase font-bold inline-block relative rounded overflow-hidden text-center" ref="upsellAddToCartButton"
            data-product-handle="${handle}"
            data-product-id="${productID}"
            data-variant-id="${variantID}"
            data-product-position="${index}"
            data-product-url="${url}"
            data-product-list="Slide-out cart reccomendations"
            data-event-category="add_to_cart_ce"
            data-event-action="${title}"
            data-event-label="${intlPrice}"
            data-a-button
      >
        <div class="a-button__text motion-safe:animate-fly-down motion-safe:group-hover:animate-fly-up a-button__text__solid px-2 pt-3 pb-2 text-center group-hover:bg-charcoal group-hover:text-white" style="animation-play-state: running;">Add to cart</div>
      </button>
    </li>`
  }

  updateUpsells (thisCart = {}) {
    // update cart reccos for most recent item
    const reccosContainer = document.querySelector('.m-slide-out-cart__upsell-slider')
    const reccosList = document.querySelector('[data-c-upsell-slider-list]')
    // const reccosControls = document.querySelector('[data-c-upsell-slider-controls]')
    const reccosControlButtons = document.querySelector('[data-c-upsell-slider-controls-buttons]')

    if (thisCart.items.length > 0) {
      // this is a promise
      cart.getUpsellsByHandle(thisCart.items[0].handle)
        .then((response) => {
          const upsells = Array.from(Object.values(response.upsells))
          if (upsells.length > 0) {
            const upsellHTML = upsells.map((item, index) =>
              this.reccosHTML(
                item.title,
                item.productID,
                item.variantID,
                item.url,
                item.imgURL,
                item.price,
                index,
                item.sku,
                item.handle
              )
            )
              .join('')

            reccosContainer.classList.remove('hidden')
            reccosList.innerHTML = upsellHTML

            // rebuild control buttons
            reccosControlButtons.innerHTML = '<button class="border-2 border-grey-700 c-slider-pdp__prev flex h-10 hover:bg-grey-700 hover:text-white focus:bg-grey-700 focus:text-white items-center justify-center mr-3 rounded-full w-10" ref="prevUpsell" aria-label="Show previous product" c-upsell-slider__controls=""><svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" class="a-svg fill-current transform rotate-180" aria-label="arrow" role="img" width="16px" height="16px" viewBox="0 0 16 16"><g clip-path="url(#a)"><g clip-path="url(#b)"><path d="m9.752 1.3-1.4 1.4 4.3 4.3H.452v2h12.2l-4.3 4.3 1.4 1.4 6.7-6.7-6.7-6.7Z" fill="#343738"></path></g></g><defs><clipPath id="a"><path fill="#fff" transform="translate(.452)" d="M0 0h16v16H0z"></path></clipPath><clipPath id="b"><path fill="#fff" transform="translate(.452)" d="M0 0h16v16H0z"></path></clipPath></defs></svg></button><button class="c-slider-pdp__next flex items-center justify-center border-2 border-grey-700 rounded-full w-10 h-10 hover:bg-grey-700 hover:text-white focus:bg-grey-700 focus:text-white" ref="nextUpsell" aria-label="Show next image"><svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" class="a-svg fill-current" aria-label="arrow" role="img" width="16px" height="16px" viewBox="0 0 16 16"><g clip-path="url(#a)"><g clip-path="url(#b)"><path d="m9.752 1.3-1.4 1.4 4.3 4.3H.452v2h12.2l-4.3 4.3 1.4 1.4 6.7-6.7-6.7-6.7Z" fill="#343738"></path></g></g><defs><clipPath id="a"><path fill="#fff" transform="translate(.452)" d="M0 0h16v16H0z"></path></clipPath><clipPath id="b"><path fill="#fff" transform="translate(.452)" d="M0 0h16v16H0z"></path></clipPath></defs></svg></button>'

            this.initUpsellButtons()
            document.dispatchEvent(new CustomEvent('cartUpsells:updated'))
          } else {
            // response might be undefined if no upsells on product, but leaving this hear in case it's not
            reccosContainer.classList.add('hidden')
            reccosList.innerHTML = ''
            // reccosControls.innerHTML = ''
            reccosControlButtons.innerHTML = ''
          }
        })
        .catch(() => {
          // response may be undefined when there are no upsells for recently added product
          // CAREFUL - this gets triggered if there is ANY error in the .then, including if can't set innerHTML of an element
          // console.log('hide reccos - error', err)
          // assume nothing to show, and clear the section
          reccosContainer.classList.add('hidden')
          reccosList.innerHTML = ''
          // reccosControls.innerHTML = ''
          reccosControlButtons.innerHTML = ''
        })
    } else {
      // console.log('hide reccos - undefined')
      // no products in cart, so no upsells
      reccosContainer.classList.add('hidden')
      reccosList.innerHTML = ''
      // reccosControls.innerHTML = ''
      reccosControlButtons.innerHTML = ''
    }
  }

  updateShippingProgressBar (subtotal) {
    const progressBarElement = this.$refs.shippingProgressBar
    const percentProgress = (subtotal / this.freeShippingMinimum) * 100

    // something here is breaking to where the totals don't update
    progressBarElement.setAttribute('aria-valuenow', percentProgress)
    progressBarElement.style.width = Math.min(Math.floor(percentProgress), 100) + '%'
  }

  initCartItemEventHandlers () {
    for (const item of this.slideOutCart.querySelectorAll('[ref="cartItem"]')) {
      const remove = item.querySelector('[ref="remove"]')

      remove.addEventListener('click', (event) => {
        item.parentNode.removeChild(item)

        fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            updates: {
              [item.dataset.itemKey]: 0
            }
          })
        })
          .then(response => response.json())
          .then((newCart) => {
            // console.log('Cart updated cart:', newCart)

            cart.cartUpdated(newCart)
          })
          .catch(console.error)
      })
    }
  }

  initUpsellButtons () {
    // old buttons will be gone from DOM, so should not have to worry about the listeners

    // set button listeners
    // cannot use this.$refs because elements did not exist when that was defined
    for (const button of this.slideOutCart.querySelectorAll('[ref="upsellAddToCartButton"]')) {
      // variant and product IDs will be in parent container dataset
      const innerElem = button.children.length > 0 ? button.children[0] : button
      const buttonHelper = new ButtonHelper(button, innerElem)
      const variantID = button.dataset.variantId

      button.addEventListener('click', (e) => {
        // Handle iOS Safari's buggy click event behavior
        e.preventDefault()
        e.stopPropagation()

        // Set text to loading
        buttonHelper.setPendingState()

        cart
          .addProductsToCart([
            {
              id: variantID,
              quantity: 1
            }
          ])
          .then(() => {
            // add GTM and Klaviyo add to cart
            // push to GTM
            window.dataLayer.push({
              event: button.dataset.eventCategory,
              event_category: button.dataset.eventCategory,
              event_action: button.dataset.eventAction,
              event_label: button.dataset.eventLabel
            })
            // End GTM event

            // Klaviyo event
            // Klaviyo's code will only allow this if the user already has an identifiable Klaviyo id - that cookie will not be available if declined in Pandectes

            if (button.dataset.productHandle) {
              return new Promise((resolve, reject) => {
                datalayer.getProductByHandle(button.dataset.productHandle)
                  .then((response) => {
                    return response
                  })
                  .then((data) => {
                    const newItem = {
                      Name: data.title,
                      ProductID: data.id,
                      ImageURL: data.image,
                      URL: `${window.location.hostname}${data.url}`,
                      Brand: data.vendor,
                      Price: `$${data.price / 100} ${window.localeInformation.currency}`,
                      $use_ip: true,
                      $is_session_activity: true
                    }
                    // this does not work - apparently the compare at price is not included in data the way it's retrieved above
                    // leaving it here in case that changse
                    if (data.compare_at_price) {
                      newItem.CompareAtPrice = `$${data.compare_at_price / 100} ${window.localeInformation.currency}`
                    }

                    // this is what sends to event to Klaviyo
                    // if pushing inside liquid file we'd be able to add cart info
                    // can't do that here, and Klaviyo's own code snippets leave it off in code variants so not worying about it
                    // console.log('pushing to learnq in storybook cart-reccos', newItem, 'window._learnq', window._learnq)

                    window._learnq.push(['track', 'Added to Cart', newItem])
                    // End Klaviyo event

                    resolve()
                  })
                  .catch((err) => {
                    console.error('Product click error:', err)

                    reject(err)
                  })
              })
            }

            // Done adding to cart state
            buttonHelper.setDoneState()

            // Reset to initial state
            buttonHelper.resetStateOnDelay()
          })

        // do not need to add pushProductClickEvent - that is for button clicks that actually go to a new PDP
      })
    }
  }
}

// On DOM Content Loaded
document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('[data-m-slide-out-cart]')
    .forEach(el => new MSlideOutCart(el))
})
